import { styled, css } from "styled-components";
import type { PropsWithChildren } from "react";
import { LegacyPageHeader } from "@wayflyer/flyui";
import { IconArrowLeft24Line as ArrowLeftIcon } from "@wayflyer/flyui-icons/24/line";

const containerCss = css`
  margin: 0;
  min-height: calc(100vh - 146px);
  display: flex;
  flex-direction: column;
  @media (max-width: 640px) {
    margin-bottom: 100px;
  }
`;

const OuterContainer = styled.div`
  ${containerCss}
  background-color: var(--palette-bg-neutral-base);
  position: relative;
  min-height: 100vh;
  @media (max-width: 1024px) {
    min-height: calc(var(--app-height) - var(--top-bar-height, 0));
  }
`;

const FullWidthPageHeader = styled(LegacyPageHeader)`
  border-top: none;
  width: 100%;
`;

const ContentContainer = styled.div`
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
`;

const ActivityContainer = styled.div`
  padding: 0;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: left;
  width: 100%;
  max-width: 735px;
  height: 100%;
  min-height: 200px;
`;

export type ChecklistActivityContainerProps = PropsWithChildren<{
  header?: { title: string; href?: string; onClick?: () => void };
}>;

/**
 * @deprecated
 */
export const ChecklistActivityContainer = ({ header, children }: ChecklistActivityContainerProps) => {
  return (
    <OuterContainer>
      {header ? (
        <FullWidthPageHeader
          title={{
            text: header.title,
            variant: "A",
            icon: ArrowLeftIcon,
            href: header.href,
            onClick: header.onClick,
          }}
        />
      ) : null}
      <ContentContainer>
        <ActivityContainer>{children}</ActivityContainer>
      </ContentContainer>
    </OuterContainer>
  );
};
